import $ from "jquery";

const scrollToTop = () => {
  const $target = $(".scroll-to-top");
  const $contactPage = $(".elementor-page-47");

  const init = () => {
    $(document).ready(function () {
      if ($contactPage.length) {
        $target.attr("style", "display:none;bottom:100px;z-index:90");
      } else {
        $target.attr("style", "display:none;");
      }
      exec();
    });
  };
  const exec = () => {
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > $(window).height() / 2) {
        $target.fadeIn();
      } else {
        $target.fadeOut();
      }
    });
    $target.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };
  init();
};

try {
  scrollToTop();
} catch (error) {
  throw Error(error.message);
}
